<template>
  <div class="base-button">
    <RouterLink
      v-if="to"
      :to="to"
      class="output-button"
      :class="{ 'output-button--active': active }"
    >
      {{ text }}
    </RouterLink>

    <button
      v-else
      type="button"
      class="output-button"
      :class="{ 'output-button--active': active }"
      @click="$emit('click')"
    >
      {{ text }}
    </button>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
  name: 'BaseButton',

  components: {
    RouterLink,
  },

  props: {
    text: {
      type: [String, Number],
      default: ' ',
    },
    to: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],
};
</script>


<style scoped>
.base-button {
  width: 100%;
  min-width: 0;
  display: flex;
  justify-content: center;
}

.output-button {
  display: block;
  width: 85%;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  text-decoration: none;

  padding: 7px 10px;
  border: 1px solid var(--color-border);
  border-radius: 0;

  background-color: var(--color-surface);
  color: var(--color-text);

  font: inherit;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  transition:
    color 150ms ease,
    background-color 150ms ease,
    border-color 150ms ease;
}

@media (hover: hover) and (pointer: fine) {
  .output-button:hover {
    border-color: var(--color-primary);
    color: var(--color-primary);
  }
}

.output-button:active {
  color: var(--color-on-primary);
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

.output-button:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

.output-button--active {
  background-color: var(--color-primary);
  color: var(--color-on-primary);
  border-color: var(--color-primary);
}

.output-button--active:hover{
  background-color: var( --color-primary);
  color: var(--color-surface-raised);
  border-color: var(--color-border);
}
</style>